import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_NAME } from "../../constants";
import { useAuth } from "../../contexts/authContext";
import { DASHBOARD_PAGE } from "../../routes";
import AuthenticationSection from "../sections/AuthenticatingSection";
import LoginSection from "../sections/LoginSection";

const glowPulse = keyframes`
  0%, 100% { text-shadow: 0 0 20px rgba(0, 255, 255, 0.3), 0 0 40px rgba(0, 255, 255, 0.1); }
  50% { text-shadow: 0 0 30px rgba(0, 255, 255, 0.5), 0 0 60px rgba(0, 255, 255, 0.2); }
`;

function HomePage() {
  const navigate = useNavigate();
  const { userHasLoggedIn, authenticationInProgress, viewer } = useAuth();

  useEffect(() => {
    if (userHasLoggedIn()) {
      navigate(DASHBOARD_PAGE);
    }
  }, [userHasLoggedIn, navigate]);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="100vh"
      w="100%"
      p={4}
      bg="secondary.800"
      position="relative"
      overflow="hidden"
      _before={{
        content: '""',
        position: "absolute",
        top: "-50%",
        left: "-50%",
        width: "200%",
        height: "200%",
        background:
          "radial-gradient(ellipse at 30% 20%, rgba(0, 255, 255, 0.04) 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, rgba(154, 3, 254, 0.03) 0%, transparent 50%)",
        pointerEvents: "none",
      }}
    >
      <Box textAlign="center" mb={8} zIndex={1}>
        <Heading
          as="h1"
          fontSize={{ base: "3xl", md: "5xl" }}
          fontFamily="'Orbitron', sans-serif"
          fontWeight="700"
          color="cyan.300"
          letterSpacing="0.1em"
          animation={`${glowPulse} 4s ease-in-out infinite`}
          mb={3}
        >
          {APP_NAME}
        </Heading>
        {viewer ? (
          <Text color="primary.200" fontSize="sm" fontWeight="300" letterSpacing="0.05em">
            Signed in as {viewer.email}
          </Text>
        ) : (
          <Text
            color="primary.300"
            fontSize="sm"
            fontWeight="300"
            letterSpacing="0.15em"
            textTransform="uppercase"
          >
            Your fitness data hub
          </Text>
        )}
      </Box>

      <Box zIndex={1} w="100%" maxW="420px">
        {authenticationInProgress ? <AuthenticationSection /> : <LoginSection />}
      </Box>
    </Flex>
  );
}

export default HomePage;
